export default "__VITE_ASSET__fc93be4b__"